module.exports = __webpack_public_path__ + "img/card_250720854.43eac414.jpg";